import * as ReactQuery from "@tanstack/react-query";
import { MutationOption, queryClient } from "libs/react-query";
import * as Brm from "services/brm";
import * as KeyFactory from "./organization-query-key-factory";

interface IOrganizationNameProps {
  organizationId: string | null;
  userId: string;
}

/**
 * Add given user to the organization
 *
 * @param param0 upload file data
 * @returns
 */
export const addOrganizationAttachedUser = ({ organizationId, userId }: IOrganizationNameProps) => {
  return organizationId === null
    ? Promise.reject(new Error("Invalid organization id"))
    : Brm.organizationApi.addOrganizationAttachedUser(organizationId, { body: userId });
};

interface IAddOrganizationAttachedUserProps {
  options?: MutationOption<typeof addOrganizationAttachedUser>;
}

/**
 * Add given user to the organization
 *
 * @returns react-query Mutation.
 */
export const useAddOrganizationAttachedUser = ({ options }: IAddOrganizationAttachedUserProps = {}) => {
  return ReactQuery.useMutation({
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries(KeyFactory.organizationKeys.all);
      queryClient.invalidateQueries(KeyFactory.organizationKeys.org(variables.organizationId));
    },
    ...options,
    mutationFn: addOrganizationAttachedUser,
  });
};
